export default __webpack_public_path__ + "static/blob8-b372d330c448e972351236d8bc881c03.svg";